import { type ApiClient, listQueryParams } from "./client";
import type { ListQuery, Page, PurchaseFilters, PurchaseRow, PurchaseTrace } from "./types";

/** Purchases: domain operations the UI depends on. Implementations: HTTP (below) and mock (src/api/mock). */
export interface PurchasesApi {
  list(query: ListQuery<PurchaseFilters>): Promise<Page<PurchaseRow>>;
  trace(id: string): Promise<PurchaseTrace>;
}

export function createHttpPurchasesApi(client: ApiClient): PurchasesApi {
  return {
    list: (q) => client.call("listPurchases", { query: listQueryParams(q) }),
    trace: (id) => client.call("getPurchaseTrace", { params: { id } }),
  };
}
